import service from "@/tools/request";
import defaultRequestErrorHandle from "@/plug/request/defaultErrorHandle";
export function getAllReport({
  institution_id,
  type,
  code,
  token,
  check,
  checkcode,
  must
}) {
  return service({
    url: "/getPatientList",
    method: "post",
    data: {
      institution_id,
      type,
      code,
      // token,
      // check,
      // checkcode,
      must
    },
  }).catch(defaultRequestErrorHandle);
}
export function getAnotherAllReport({
  institution_id,
  type,
  code,
  token,
  check,
  checkcode,
  must
}) {
  return service({
    url: "/getAnotherPatientList",
    method: "post",
    data: {
      institution_id,
      type,
      code,
      // token,
      // check,
      // checkcode,
      must
    },
  }).catch(defaultRequestErrorHandle);
}
export function getPatientInfo({ exam_id }) {
  return service({
    url: "/getPatientInfo",
    method: "post",
    data: {
      exam_id,
    },
  }).catch(defaultRequestErrorHandle);
}
export function getPaperReport({ id }) {
  return service({
    url: "/getPaperReport",
    method: "post",
    data: {
      id,
    },
  }).catch(defaultRequestErrorHandle);
}
export function makeOutLink({
  url,
  overdueTime,
  examId,
  phone,
  report,
  study_id,
  anonymous,
  encrypt,
}) {
  return service({
    url: "/makeOutLink",
    method: "post",
    data: {
      url,
      overdueTime,
      examId,
      phone,
      report,
      study_id,
      anonymous,
      encrypt,
    },
  }).catch(defaultRequestErrorHandle);
}

export function decodeSecretData({ data }) {
  return service({
    url: "/link/decodeSecretData",
    method: "post",
    data: {
      data,
    },
  }).catch(defaultRequestErrorHandle);
}

export function getReportBySecretData({ data, code }) {
  const params = { data };
  if (code !== undefined && code !== null && code !== "") {
    params.code = code;
  }

  return service({
    url: "/link/getReportBySecretData",
    method: "post",
    data: params,
  }).catch(defaultRequestErrorHandle);
}

export function getReportBySecretExam({ data, code }) {
  const params = { data };
  if (code !== undefined && code !== null && code !== "") {
    params.code = code;
  }

  return service({
    url: "/link/getReportBySecretExam",
    method: "post",
    data: params,
  }).catch(defaultRequestErrorHandle);
}

export function getDockList({ institution_id, type, code }) {
  return service({
    url: "/dock/getList",
    method: "post",
    data: {
      institution_id,
      type,
      code,
    },
  }).catch(defaultRequestErrorHandle);
}
export function dockSendEmail({study_id, email}) {
  return service({
    url: "/dock/sendEmail",
    method: "post",
    data: {
      study_id,
      email
    },
  }).catch(defaultRequestErrorHandle);
}
export function ready2OutFilmPay({
  id,
  openid
}) {
  return service({
    url: '/ready2OutFilmPay',
    method: 'post',
    data: {
      id,
      openid
    }
  }).catch(defaultRequestErrorHandle)
}
